export function buildEmbeddedScript(apiBase: string): string {
    return `
    <script>
        const API_BASE = "${apiBase}";

        async function handleContactSubmit(event) {
            event.preventDefault();
            if (!API_BASE) return;
            
            const form = event.target;
            const status = form.querySelector('.form-status');
            const btn = form.querySelector('button');
            const data = Object.fromEntries(new FormData(form));

            try {
                btn.disabled = true;
                status.innerText = 'Enviando...';
                status.style.color = '#64748b';

                const res = await fetch(\`\${API_BASE}/contact\`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                });

                if (res.ok) {
                    status.innerText = '✓ ¡Mensaje enviado correctamente!';
                    status.style.color = '#16a34a';
                    form.reset();
                } else {
                    throw new Error('Error en el servidor');
                }
            } catch (err) {
                status.innerText = '✗ Error al enviar. Inténtalo de nuevo.';
                status.style.color = '#dc2626';
            } finally {
                btn.disabled = false;
            }
        }

        async function handleReservationSubmit(event) {
            event.preventDefault();
            if (!API_BASE) return;

            const form = event.target;
            const status = form.querySelector('.form-status');
            const btn = form.querySelector('button');
            const data = Object.fromEntries(new FormData(form));

            try {
                btn.disabled = true;
                status.innerText = 'Procesando reserva...';
                status.style.color = '#64748b';

                const res = await fetch(\`\${API_BASE}/reservations\`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                });

                if (res.ok) {
                    status.innerText = '✓ ¡Reserva solicitada correctamente!';
                    status.style.color = '#16a34a';
                    form.reset();
                } else {
                    throw new Error('Error en el servidor');
                }
            } catch (err) {
                status.innerText = '✗ Error al solicitar reserva. Inténtalo de nuevo.';
                status.style.color = '#dc2626';
            } finally {
                btn.disabled = false;
            }
        }
    </script>`;
}
